import React from "react";
import Carousel from "./Carousel";
import PageTitle from "./components/PageTitle";
import Feature from "./Feature";
import ScheduleTable from "./Schedule";

const Home = () => {
  PageTitle(
    "Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop - we buy, we sell, we loan, we offer buybacks"
  );
  return (
    <div>
      <Carousel />
      <Feature />
      <ScheduleTable />
    </div>
  );
};

export default Home;
